import { HttpRequest, HttpMethod } from "./http";

class ShippingConfigProvider extends HttpRequest {

	// List all configured sale channels with resolved names + shipping_map.
	// GET /api/v1/shipping-config -> envelope Data[]
	ShippingConfigList(params) {
		return this.request(HttpMethod.Get, `/api/v1/shipping-config`, params);
	}

	// Dropdown lookups (sale_channels, payment_methods, shipping_providers).
	// GET /api/v1/shipping-config/options -> envelope Datum
	ShippingConfigOptions(params) {
		return this.request(HttpMethod.Get, `/api/v1/shipping-config/options`, params);
	}

	// Upsert config for one sale channel.
	// PUT /api/v1/shipping-config/:sale_channel_id
	ShippingConfigUpdate(saleChannelId, params) {
		return this.request(HttpMethod.Put, `/api/v1/shipping-config/${saleChannelId}`, params);
	}

}

export default ShippingConfigProvider
